import { DateTime } from "luxon";
import { useMemo } from "react";
import { useHasRequestOutreach } from "../../../hooks/useRequestOutreach";
import { useOneTimeNotice } from "../../UIToolkit/molecules/OneTimeNotice";
import type { OutreachCoachMark } from "./RequestOutreachEntry";

const NOTICE_KEY = "request_outreach_coach_mark";
/** The highlight introduces a new button; past this date it is just a button. */
const EXPIRES_AT = DateTime.fromISO("2027-03-31T23:59:59Z");

/** The "Who we're asking" first-open highlight, until the user opens the popup once. `null` when it's done or not offered. */
export const useOutreachCoachMark = (): OutreachCoachMark => {
	const hasOutreach = useHasRequestOutreach();
	const { isEligible, dismiss } = useOneTimeNotice(NOTICE_KEY, { expiresAt: EXPIRES_AT });
	// Memoized: the mark goes to a memo'd request card, and `dismiss` is already stable.
	return useMemo(() => (hasOutreach && isEligible ? { dismiss } : null), [hasOutreach, isEligible, dismiss]);
};
